import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
import firebase from 'firebase/compat/app';
import { Capacitor } from '@capacitor/core';

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'dashboard',
    component: () => import('../views/pages/Dashboard.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('../views/pages/Analytics.vue'),
    meta: {
      requiresAuth: true,
      layout: "authenticated"
    }
  },
  {
    path: '/analyticsadvanced',
    name: 'analyticsadvnaced',
    component: () => import('../views/pages/AnalyticsAdvanced.vue'),
    meta: {
      requiresAuth: true,
      layout: "authenticated"
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('../views/pages/Notifications.vue'),
    meta: {
      requiresAuth: true,
      layout: "authenticated"
    }
  },
  {
    path: '/help',
    name: 'help-center',
    component: () => import('../views/pages/HelpCenter.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/help/:slug',
    name: 'help-article',
    component: () => import('../views/pages/HelpArticle.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/bundleanalytics',
    name: 'bundleanalytics',
    component: () => import('../views/pages/BundleAnalytics.vue'),
    meta: {
      requiresAuth: true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/operatingexpenses',
    name: 'fixedpayments',
    component: () => import('../views/pages/FixedPayments.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/multi-store-dashboard',
    name: 'multi-store-dashboard',
    component: () => import('../views/pages/MultiStoreDashboard.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },

  {
    path: '/settings/product-cost-general',
    name: 'product-cost-general',
    component: () => import('../views/pages/setup/ProductCostGeneral.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/revenue',
    name: 'revenue',
    component: () => import('../views/pages/setup/Revenue.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/ios',
    name: 'ios',
    component: () => import('../views/pages/setup/iosSetup.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/orderimport',
    name: 'orderImported',
    component: () => import('../views/pages/setup/ImportedOrders.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/multi-store-settings',
    name: 'multi-store-settings',
    component: () => import('../views/pages/setup/MultiStoreSettings.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/general',
    name: 'general',
    component: () => import('../views/pages/setup/General.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/integrations/paypal/return',
    name: 'paypal-return',
    component: () => import('../views/pages/setup/PayPalReturn.vue'),
    meta: {
      requiresAuth: true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/productcosts',
    name: 'productcosts',
    component: () => import('../views/pages/setup/ProductCosts.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/settings/marketing',
    name: 'marketing',
    component: () => import('../views/pages/setup/Marketing.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/redirect.html',
    name: 'redirect',
    component: () => import('../views/userpages/redirect.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },

  // shopify oauth
  {
    path: '/shopify-oauth',
    name: 'oauth',
    component: () => import('../views/shopify/oauth.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/shopify-oauth-completed',
    name: 'shopify-oauth-completed',
    component: () => import('../views/shopify/completed.vue'),
    meta: {
      noCheck: true
    }
  },

  {
    path: '/robtronic',
    name: 'affiliate-robin',
    component: () => import('../views/userpages/affiliateRobin.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/admincenter',
    name: 'admincenter',
    component: () => import('../views/userpages/AdminCenter.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/admincenter/profit-test',
    name: 'admincenter-test',
    component: () => import('../views/userpages/TestStoreLogin.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacy.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/terms.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/datadeletionrequest',
    name: 'datadeletion',
    component: () => import('../views/DataDeletionInstruction.vue'),
    meta: {
      noCheck: true
    }
  },

  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('../views/pricing.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/partner-program',
    name: 'partner-program',
    component: () => import('../views/partnerProgram.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/top-dropshipping-profit-trackers',
    name: 'top-dropshipping-profit-trackers',
    component: () => import('../views/topDropshippingProfitTrackers.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/dropshipping-profit-calculator',
    name: 'dropshipping-profit-calculator',
    component: () => import('../views/dropshippingProfitCalculator.vue'),
    meta: {
      noCheck: true
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/adminView.vue'),
    meta: {
      requiresAuth :true,
      layout: "authenticated"
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home.vue'),
    meta: {
      noCheck: true
    }
  },

  // Serve 404 error page
  {
    path: '*',
    name: 'Not Found',
    component: () => import('../views/page404.vue'),
  },
  {
    path: '/assign-refunds',
    name: 'assign-refunds',
    component: () => import('../views/pages/AssignRefunds.vue'),
    meta: {
      requiresAuth: true,
      layout: "authenticated"
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.noCheck) {
    return next();
  }

  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (store != null && currentUser) {
    if (store.getters['user/getUser'] != null && Object.keys(store.getters['user/getUser']).length === 0) {
      store.dispatch('user/SetUser', currentUser)
    }

    const accessToken = Vue.cookie.get('shopify_accessToken');
    if (store.state.api.shopify_access_code == null && accessToken) {
      store.dispatch("api/initiateApi", {
        access_code: accessToken,
        shop: currentUser.uid
      })
    }
  }

  if (requiresAuth && !currentUser) {
    return next(Capacitor.isNativePlatform() ? '/admincenter' : '/home');
  }

  return next();
});

export default router
